import { ColumnMeta, Corpus } from "./corpus.interface";

export enum TRANSFORM_TYPE {
  COLUMN_TYPES = "columnType",
  FIND_REPLACE = "findReplace",
  FIND_DELETE_ROWS = "removeRows",
  SAMPLE_DATA = "dataSampling",
  TOKENIZE_SENTENCES = "tokenizeSentences",
}

export interface Transform {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  owner: string | null;
  corpusId: number;
  transformType: string; // TRANSFORM_TYPE
  details: any;
  beforeEsIndex: string | null;
  afterEsIndex: string | null;
  beforeColumnMeta: ColumnMeta;
  afterColumnMeta: ColumnMeta;
  corpus?: Corpus;
}

export interface TransformWithCorpus extends Transform {
  corpus: Corpus;
}
